// InactivityAutoSignOut.tsx
import { useInactivityAutoSignOutHook } from "@utils/inactivityAutoSignOutHook";
import React from "react";

const InactivityAutoSignOut: React.FC = () => {
  useInactivityAutoSignOutHook();
  return null; // no UI needed
};

export default InactivityAutoSignOut;
